import React from 'react';

function Spinner() {
  return (
    <div style={{ textAlign: 'center' }}>
      <i className="fa fa-spinner fa-spin" style={{ fontSize: '36px' }}></i>
    </div>
  );
}

export default Spinner;
